import { Injectable, OnDestroy } from '@angular/core';
import { FrontendLogger, NotificationMain } from '@biz-nest/notification-client';
import { WebStorageService } from '@front-shared-lib';
import { Subject } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService
implements OnDestroy {
  static notifUnreadCount: number;
  private eventSource?: EventSource;
  // notif for main auth user
  private notificationSubject = new Subject<{
    notification: NotificationMain, action: 'delete' | 'create' | 'update'}>();

  private unReadCountSubject = new Subject<number>();

  // notif for main auth user
  private notificationSubjectMainAuthUser = new Subject<{
    notification: NotificationMain, action: 'delete' | 'create' | 'update'}>();

  private unReadCountSubjectMainAuthUser = new Subject<number>();
  // notif for company
  private notificationSubjectCompany = new Subject<{
    notification: NotificationMain, action: 'delete' | 'create' | 'update'}>();

  private unReadCountSubjectCompany = new Subject<number>();
  // notif for commerce user
  private notificationSubjectCommerceUser = new Subject<{
    notification: NotificationMain, action: 'delete' | 'create' | 'update'}>();

  private unReadCountSubjectCommerceUser = new Subject<number>();

  constructor(
    private dataService: DataService,
    private storage: WebStorageService
  ) { }

  connect(notifServer: string) {
    this.disconnect();
    // Make sure to include credentials in the request

    const token = this.storage.get('access-token');
    const url = `${notifServer}stream${token ? `?token=${encodeURIComponent(token)}` : ''}`;

    FrontendLogger.info('Connecting to notification server', url);

    this.eventSource = new EventSource(url);

    this.eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data.notification) {
        this.notificationSubject.next({
          notification: data.notification,
          action: data.action
        });
      }

      if (data.unreadCount) {
        this.unReadCountSubject.next(data.unreadCount);
      }

      if (data.targetId === this.dataService.authUser?._id) {
        if (data.notification) {
          this.notificationSubjectMainAuthUser.next({
            notification: data.notification,
            action: data.action
          });
        }

        if (data.unreadCount) {
          this.unReadCountSubjectMainAuthUser.next(data.unreadCount);
        }
      }

      if (data.targetId === this.dataService.currentCompany?._id) {
        if (data.notification) {
          this.notificationSubjectCompany.next({
            notification: data.notification,
            action: data.action
          });
        }

        if (data.unreadCount) {
          this.unReadCountSubjectCompany.next(data.unreadCount);
        }
      }

      if (data.targetId === this.dataService.buyerProfile?._id ||
        data.targetId === this.dataService.staffProfile?._id ||
        data.targetId === this.dataService.vendorManagerProfile?._id ||
        data.targetId === this.dataService.deliveryManagerProfile?._id
      ) {
        if (data.notification) {
          this.notificationSubjectCommerceUser.next({
            notification: data.notification,
            action: data.action
          });
        }

        if (data.unreadCount) {
          this.unReadCountSubjectCommerceUser.next(data.unreadCount);
        }
      }
    };

    this.eventSource.onerror = () => {
      this.eventSource?.close();
      // Reconnect after a delay

      setTimeout(() => this.connect(notifServer), 5000);
    };
  }

  getNotificationSubject() {
    return this.notificationSubject.asObservable();
  }

  getAuthUserNotifications() {
    return this.notificationSubjectMainAuthUser.asObservable();
  }

  getCompanyNotifications() {
    return this.notificationSubjectCompany.asObservable();
  }

  getCommerceUserNotifications() {
    return this.notificationSubjectCommerceUser.asObservable();
  }

  getAuthUserUnReadCount() {
    return this.unReadCountSubjectMainAuthUser.asObservable();
  }

  getCompanyUnReadCount() {
    return this.unReadCountSubjectCompany.asObservable();
  }

  getCommerceUserUnReadCount() {
    return this.unReadCountSubjectCommerceUser.asObservable();
  }

  disconnect() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = undefined;
    }
  }

  ngOnDestroy() {
    this.disconnect();
  }
}
